/**
 * Origem canônica do site. Toda URL absoluta sai daqui.
 * O Netlify serve este host e redireciona o www (301) para ele.
 */
export const SITE_ORIGIN = 'https://johnnyvaz.com.br';

/** URL absoluta de um caminho do site: `siteUrl('/palestras')` → `https://johnnyvaz.com.br/palestras`. */
export function siteUrl(path = '/'): string {
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
